import { io } from 'socket.io-client';

const URL: string = process.env.REACT_APP_DEREX_SOCKET_SERVER as string;

const socket = io(URL);

export default socket;
